<template>
  <div>
    <vxe-table
      column-key
      ref="wxeTable"
      border
      v-loading="loading"
      element-loading-text="系统拼命加载中..."
      element-loading-background="rgba(255, 255, 255, 0.8)"
      :height="height"
      :data.sync="tableData"
      row-id="id"
      show-overflow
      :checkbox-config="{ checkMethod }"
      :cell-class-name="cellClassName"
      highlight-current-row
      resizable
      size="mini"
      @checkbox-change="selectChange"
      @checkbox-all="selectAll"
    >
      <vxe-table-column
        v-if="showSelectionCol"
        type="checkbox"
        width="50"
        fixed="left"
      ></vxe-table-column>
      <vxe-table-column type="seq" title="序号" width="50"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in tableHead"
        :width="item.width"
        :min-width="200"
        :key="title === 'daoru' ? index + 'a' : index + 'b'"
        :field="item.prop"
        :title="item.label"
        :sortable="item.sort"
        @sort-method="sortMethod"
      >
        <template slot-scope="scope">
          <span v-if="item.date">{{
            scope.row[item.prop] | formatDateAll
          }}</span>
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <p v-if="totalName.length > 0">{{ totalName }}：{{ total }}</p>
  </div>
</template>
<script>
export default {
  props: {
    showSelectionCol: {
      type: Boolean,
      default: true,
    },
    totalName: {
      type: String,
      default: '',
    },
    total: {
      default: 0,
    },
    sort: {
      type: Boolean,
      required: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    height: {
      type: Number,
      default: 500,
    },
    tableHead: {
      type: Array,
      required: true,
      default: () => {
        return [];
      },
    },
    title: {
      type: String,
      default: 'title',
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    // 提示字段名
    importRowErrMsg: {
      type: String,
      default: 'errorMsg',
    },
    isDisabled: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {};
  },
  methods: {
    removeSelecteds() {
      this.$refs.wxeTable.removeCheckboxRow();
    },
    selectChange({ records }) {
      this.$emit('wxe-table-select', records);
    },
    selectAll({ records }) {
      this.$emit('wxe-table-select', records);
    },
    toggleRowSelection(row) {
      this.$refs.wxeTable.toggleRowSelection(row);
    },
    sortMethod(a, b) {
      let x = a.errorMsg;
      let y = b.errorMsg;
      return x < y ? -1 : x > y ? 1 : 0;
    },
    // 设置table checkbox disable
    checkMethod({ row }) {
      // 为 true checkbox 可以选择
      // 有导入功能页面的表格，导入信息错误时表格行禁用
      if (row[this.importRowErrMsg] && this.isDisabled) {
        return false;
      }
      return true;
    },
    // 单元格的样式设置
    cellClassName({ row, $columnIndex }) {
      if (!this.showSelectionCol) {
        if ($columnIndex === 1 && row[this.importRowErrMsg]) {
          return 'wxeTable-disable';
        }
      } else {
        if ($columnIndex === 2 && row[this.importRowErrMsg]) {
          return 'wxeTable-disable';
        }
      }
    },
  },
};
</script>

<style>
.vxe-checkbox > input:checked + .checkbox--icon,
.vxe-checkbox.is--indeterminate > input + .checkbox--icon {
  background-color: #f26921;
  border-color: #f26921;
}
.vxe-checkbox.size--mini > input + .checkbox--icon,
.vxe-checkbox.size--small > input + .checkbox--icon {
  font-size: 12px;
}
.vxe-checkbox > input:checked + .checkbox--icon:before {
  top: 0.15em;
  left: 0.4em;
  border-width: 0.1em;
}
.vxe-table--tooltip-wrapper {
  z-index: 10000 !important;
}
.wxeTable-disable {
  background: #b2b2b2;
}
</style>
